<template>
  <div class="vue-route-transition">
    <transition :name="state.pageDirection" @leave="setRouterMap" >
<!--       <keep-alive v-if="$route.meta.keepAlive!==false" :key="$route.fullPath" :include="['index', 'home', 'pickingForm']">
        <router-view></router-view>
      </keep-alive>
      <router-view v-else :key="$route.fullPath"></router-view>  -->
    <!-- 把组件名称，不是路由名哦，加入到include就可以实现缓存 -->
    <keep-alive :include="['index', 'home', 'pickingForm']">
        <router-view></router-view>
    </keep-alive>
    </transition>
    <!-- <div class="move"  v-drag><div class="iconbox"><i class="icon-zhuye1"><i class="path1"></i><i class="path2"></i><i class="path3"></i></i></div> </div> -->
  </div>
</template>
<script>
export default {
  name: 'vTransition',
  props: {
  },
  data: function () {
    return {
     self:this,
      state: {
        routerMap: {},
        pageDirection: 'fade',
        routeChain: [],
      },
         widthandheight:{
                width: '50px',
                height:'50px'
            }
    }
  },
  methods: {
    //前进就添加记录
    addRouteChain (route) {
      let _num=this.outinnum;
         this.state.routeChain.push({
            path: route.path,
            fullPath:route.fullPath//路由全称包括参数，很主要，主要作用在同一个页面点击打开当前面页，参数不一样的情况下使用
          })
          sessionStorage.setItem('$$routeChain', JSON.stringify(this.state.routeChain)) 

    },
    //删除记录
    popRouteChain () {
      
      this.state.routeChain.pop()
      sessionStorage.setItem('$$routeChain', JSON.stringify(this.state.routeChain))
    },
    setPageDirection ({dir, to, from}) {
      this.state.pageDirection = dir//动画名称
      this.state.routerMap['to'] = to.path
      this.state.routerMap['from'] = from.path
    },
    setRouterMap () {
      let dir = this.state.pageDirection//动画名称
      let to = this.state.routerMap.to.replace(/\//g, '_')
      let from = this.state.routerMap.from.replace(/\//g, '_')
       
      try {
        if (dir === 'slide-left') {
          // 进入
          this.state.routerMap[from] = document.getElementById(from).scrollTop
        } else if (dir === 'slide-right') {
          // 返回
          if (this.$route.meta.keepAlive !== false && document.getElementById(to)!=null) {
             this.$nextTick(() => {//必需等页面渲染完成再执行---因为所有页面都在v-if判断是否加载成功 
                document.getElementById(to).scrollTop = this.state.routerMap[to];//拿到上一页的位置
             })
          }
        } else {

        }
      } catch (error) {

      }
    }
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function(el, binding, vnode) {
   
        vnode = vnode.elm;
          let startX = 0,startY = 0,ticking = true,raf;
          
          const screenWidth = document.body.clientWidth; // body当前宽度
          const screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
          const dragDomWidth = vnode.offsetWidth; // 对话框宽度
          const dragDomheight = vnode.offsetHeight; // 对话框高度
          const minDragDomLeft = vnode.offsetLeft;
          const maxDragDomLeft = screenWidth - vnode.offsetLeft - dragDomWidth;
          const minDragDomTop = vnode.offsetTop;
          const maxDragDomTop = screenHeight - vnode.offsetTop - dragDomheight;
        el.ontouchstart = e => {
           ticking = true;
          startX = e.touches[0].pageX - (vnode.lefts || -vnode.offsetWidth / 2);
          startY =e.touches[0].pageY - (vnode.tops || -vnode.offsetHeight / 2);
        };
          el.ontouchmove = e => {
        
       
            //阻止页面的滑动默认事件
           // e.preventDefault();
            //1先触摸移动
            vnode.lefts = e.touches[0].pageX - startX;
            vnode.tops = e.touches[0].pageY - startY;
            
            //vnode.tops=0;

            // 边界处理
            if (-vnode.lefts > minDragDomLeft) {
              vnode.lefts = -minDragDomLeft;
            } else if (vnode.lefts > maxDragDomLeft) {
              vnode.lefts = maxDragDomLeft;
            }

            if (-vnode.tops > minDragDomTop) {
              vnode.tops = -minDragDomTop;
            } else if (vnode.tops > maxDragDomTop) {
              vnode.tops = maxDragDomTop;
            }
            raf = requestAnimationFrame(function() {
              ticking = false;
              vnode.style.webkitTransform = vnode.style.transform ="translate3D(" + vnode.lefts + "px," + vnode.tops + "px,0)";
            });
          };
          el.ontouchend = e => {
  
            //e.preventDefault(); //阻止其他事件
            if (ticking == true) {
                //$router.push({ path: "/" });
                window.location.href = '/';
            }
          };
     
      }
    }
  },
  mounted () {
/*     let _sysConfig= this.$store.getters.getSysConfig;
    this.$Play.show(_sysConfig.aliDomain);//这里是插入全局播放器的 */
   this.state.routeChain=sessionStorage.getItem('$$routeChain')===null?[]:JSON.parse(sessionStorage.getItem('$$routeChain'))
   // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
    this.$router.beforeEach((to, from, next) => {
      // 定义一个可以记录路由路径变化的数据，这里用sessionStorage,或者在window.routeChain等变量
      let routeLength = this.state.routeChain.length
      
       let lastBeforeRoute = routeLength>=2?this.state.routeChain[routeLength - 2]:null//获得后退时的页面名
 
        //如果后退时的页面名和to.path的名字一样，即后退，同时也判断全称路由是否相等
        if (lastBeforeRoute!=null && lastBeforeRoute.path === to.path &&lastBeforeRoute.fullPath ==to.fullPath) {//后退的时候执行

          this.popRouteChain()//删除记录
          this.setPageDirection({dir: 'slide-right', to, from})
        } else {//前进新页面的时候执行
            if(routeLength==0)
            {
              this.addRouteChain(from)
            }
           this.addRouteChain(to)
          this.setPageDirection({dir: 'slide-left', to, from})
        }
      next()
    })
  }
}
</script>

<style scoped>
        .move {width: 50px;height: 50px;position: fixed;bottom: 45px;right: 0px;z-index: 1000000;touch-action: none;  
  transform: translate(-50%, -50%);}
        .move i { font-size: 2.8rem; font-style: normal }
        .move .iconbox { background-color: #e5e5e5; width: 50px; height: 50px; border-radius: 50%; text-align: center; line-height: 60px; }
.vue-route-transition{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backface-visibility: hidden;
  perspective: 1000;
}
.fade-enter-active{
  animation: pageFadeIn 400ms forwards;
}
@keyframes pageFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*路由前进，退出*/

.slide-left-leave-active {
  animation: pageFromCenterToLeft 400ms forwards;
  z-index: 1;
}

/*路由后退，进入*/

.slide-right-enter-active {
  animation: pageFromLeftToCenter 400ms forwards;
  z-index: 1;
}

/*路由后退，退出*/

.slide-right-leave-active {
  animation: pageFromCenterToRight 400ms forwards;
  z-index: 10;
  box-shadow: -3px 0  5px rgba(0,0,0,.1);
}

/*路由前进，进入*/

.slide-left-enter-active {
  animation: pageFromRightToCenter 400ms forwards;
  z-index: 10;
  box-shadow: -3px 0  5px rgba(0,0,0,.1);
}

/*-------------------------------*/

/*路由前进，进入*/

@keyframes pageFromRightToCenter {
  from {
    /* left: 100%; */
    transform: translate3d(100%, 0, 0);
    opacity: 1;
  }
  to {
    /* left: 0; */
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

/*路由前进，退出*/

@keyframes pageFromCenterToLeft {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    /* left:0; */
  }
  to {
    opacity: 0.5;
    transform: translate3d(-20%, 0, 0);
    /* left:-20%; */
  }
}

/*路由后退，进入*/

@keyframes pageFromLeftToCenter {
  from {
    opacity: .5;
    transform: translate3d(-20%, 0, 0);
    /* left: -20%; */
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    /* left: 0; */
  }
}

/*路由后退，退出*/

@keyframes pageFromCenterToRight {
  from {
    /* left: 0; */
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  to {
    /* left: 100%; */
    transform: translate3d(100%, 0, 0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v-transition.vue